<template>
  <div
    id="previewAll"
    class="previewDisplay"
    :class="{ overviewShown: overviewShown , 'is-visible-preview' : isVisible }"
  >
    <div id="exit" class="gjs-off-prv exit_preview" @click="showPreview">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" viewBox="0 0 401.994 402">
        <g transform="translate(-296.982 -165)">
          <path
            d="M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z"
            transform="translate(364 232)"
            fill="#fff"
          />
          <g id="error" transform="translate(296.982 165)">
            <path
              d="M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </svg>
      <div class="exit-container">
        <div class="exit-alert animated fadeOutUp" id="animatedExit">
          <h5>{{ $t('labels.press') }}</h5>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 401.994 402">
            <g transform="translate(-296.982 -165)">
              <path
                d="M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z"
                transform="translate(364 232)"
                fill="#fff"
              />
              <g id="error" transform="translate(296.982 165)">
                <path
                  d="M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </svg>
          <h5>{{ $t('labels.exit_fullScreen') }}</h5>
        </div>
      </div>
    </div>
    <div class="reveal">
      <div class="slidesParent preview-scaling" :style="devices.style" :class="deviceType">
        <div class="slides">
          <section
            v-if="isVisible"
            v-for="slide in slides"
            :data-transition="slide.transition"
            :data-autoslide="slide.duration"
          >
            <div v-html="getHtml(slide.html)" class="" style="height: 100%;"></div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reveal from 'reveal.js/js/reveal';
import Mixin from '../mixins/Mixin.js';
import { mapActions, mapGetters } from 'vuex';
import postMixin from '../mixins/PostCssVw';
import { TweenMax } from 'gsap';
import flatElements from '../store/flatElements';

export default {
  name: 'preview',
  mixins: [Mixin, postMixin],
  data() {
    return {
      fileDecorated: false,
      isVisible: false,
      isChanged: false,
      PreviewScreens: [],
      dataStored: [],
      overviewShown: false,
      scriptEl: '',
      videoObject: {},
      slideId: 0,
      typePreview: '',
      getSelectedDevice: '',
      timeout: 0,
      scale:{}
    };
  },
  watch: {
    isVisible(val) {
      //Reveal.sync();
      //Reveal.loadSlide();
      if (val) {
        setTimeout(() => {
          Reveal.initialize({
            autoSlide: 20000,
            loop: true,
            width: '100%',
            height: '100%',
            margin: 0,
            minScale: 1,
            maxScale: 1,
          });
          Reveal.slide(0);
          Reveal.configure({
            keyboard: {
              70: null, // don't do anything when SPACE is pressed (i.e. disable a reveal.js default binding)
            },
          });
          let self = this;
          self.mountOneSlide();
          Reveal.addEventListener('ready', function(event) {
            const tickers = Reveal.getSlides()[0].querySelectorAll('#newsTicker');

            let index = 0;
            let interval = setInterval(() => {
              index++;
              tickers.forEach(t => {
                const playBtn = t.querySelector('.bn-play');
                if (playBtn) {
                  playBtn.click();
                  clearInterval(interval);
                }
                if (index === 100) {
                  clearInterval(interval);
                }
              });
            }, 100);
            self.setRevealUrlsCkeditors(event);
          });
        }, 500);
        this.reloadSlides();
      }
    },
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      canvasSize: 'common/getCanvasSize',

      ListSvgObject: 'common/getListSvgObject',
      route: 'getRoute',
      tmpId: 'getTmpId',
      dispositions: 'dispositions/getSelectedDispositions',
      selected: 'slides/getSelected',
      current: 'slides/getCurrent',
      selectedSlides: 'slides/getAllSelected',
      selectedSegments: 'segments/getAllSelectedSlides',
      deviceType: 'common/getDeviceType',
      VideoGeneriqueDebut: 'getVideoGeneriqueDebut',
      VideoGeneriqueFin: 'getVideoGeneriqueFin',
      getCurrent: 'slides/getCurrent',
      getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
      getByIndex: 'slides/getByIndex',
      paramsClient: 'getParamsClients',
      getConfigurationSvg: 'common/getConfigurationSvg',
    }),
    selected() {
      return this.$route.name === 'segment' ? this.selectedSlides : this.selectedSegments;
    },
    slides() {
      let css = '';
      return this.selected.map(slide => {
        css = this.postcss(slide.css, this.deviceType);
        // To handle slides with duration = 0s
        const duration = slide.options.duration ? slide.options.duration * 1000 : 1;
        //----------------------------------------------
        //convert img to svg
        let newHtml = this.convertImgToSVG(this.cmdInlineHtml(slide.html, css));
        //convert style ck-editor px to vm

        let html = this.convertCKEditorPXToVW(newHtml);

        //this.convertCKEditorPXToem(newHtml);

        //----------------------------------------------
        return {
          transition: slide.transition.in + ' ' + slide.transition.out,
          duration,
          //html: this.cmdInlineHtml(slide.html, css),
          html: html,
        };
      });
    },
    devices() {
      this.getSelectedDevice = this.paramsClient.display_devices.filter(
        s => s.name === this.deviceType,
      );
      if (this.getSelectedDevice.length === 0) {
        this.getSelectedDevice = this.paramsClient.display_devices;
      }
      return {
        name: this.getSelectedDevice[0].name,
        classes: this.getSelectedDevice[0].className,
        style: {
          width: this.getSelectedDevice[0].fixedSize
            ? this.getSelectedDevice[0].fixedSize.width + 'px !important'
            : this.getSelectedDevice[0].width + '!important',
          height: this.getSelectedDevice[0].fixedSize
            ? this.getSelectedDevice[0].fixedSize.height + 'px !important'
            : this.getSelectedDevice[0].height + '!important',
          overflow: 'hidden',
        },
      };
    },
  },

  methods: {
    ...mapActions(['deleteScreensById']),
    playAnimationSVG(id) {
      var all = [];
      var newConf = this.getConfigurationSvg(id);
      var x = Object.assign({}, newConf);
      flatElements(x.currentConf.conf, all);
      let data = {
        all: all,
        x: x,
      };
      this.$store.commit('animateElement', data);
    },
    newSvg(img, svg) {
      let temp = document.createElement('div');
      temp.classList.add('AnimatSvg');
      temp.id = img.id;
      temp.innerHTML = svg;
      if (img != null) {
        if (img.style.width != null) temp.style.width = img.style.width;
        if (img.style.height != null) temp.style.height = img.style.height;
        if (img.style.top != null) temp.style.top = img.style.top;
        if (img.style.left != null) temp.style.left = img.style.left;
        temp.style.position = 'absolute';
        return temp;
      } else return temp;
    },
    convertImgToSVG(html) {
      let stringHtml = html;
      var temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = stringHtml;
      if (this.ListSvgObject != null) {
        this.ListSvgObject.forEach(o => {
          let oldimg = temporalDivElement.querySelector('#' + o.file.idImg);
          if (oldimg != null) {
            let parentDiv = temporalDivElement.querySelector('.body');
            let newElement = this.newSvg(oldimg, o.newTagSvg);
            parentDiv.replaceChild(newElement, oldimg);
          }
        });
      }
      return temporalDivElement.outerHTML;
    },
    convertCKEditorPXToVW(htmlCode) {
      let self = this;
      //  Cleaning
     /* htmlCode = htmlCode.replace(/(\n\r|\n|\r)/gm,"\n");
      htmlCode = htmlCode.replace(/(\n \n)/gm,"\n\n");
      htmlCode = htmlCode.replace(/(\n	\n)/gm,"\n\n");
      htmlCode = htmlCode.replace(/(\n\n\n\n\n\n)/gm,"\n\n");
      htmlCode = htmlCode.replace(/(\n\n\n\n\n)/gm,"\n\n");
      htmlCode = htmlCode.replace(/(\n\n\n\n)/gm,"\n\n");
      htmlCode = htmlCode.replace(/(\n\n\n)/gm,"\n\n");*/
      //  exp : &nsmp;
     /* htmlCode = htmlCode.replace(/&[a-z;A-Z;0-9]*;/g, '');
      htmlCode = htmlCode.replace(/&#[a-z;A-Z;0-9]*;/g, '');
      htmlCode = htmlCode.replace(/&\u[a-z;A-Z;0-9]*;/g, '');
      var exp = new RegExp(String.fromCharCode(8203),"g");
      htmlCode = htmlCode.replace(exp,'');*/


      let stringHtml = htmlCode;
      var temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = stringHtml;
      let alltext = temporalDivElement.querySelectorAll('.cke_dialog_fontSize');


      alltext.forEach(oldtext => {
        if (oldtext != null) {
          let newoldtext = self.fontSizeCKeditorToVw(oldtext.outerHTML);
          let parentDiv = oldtext.parentNode;
          newoldtext = newoldtext.replace(/<br>/g," <br/>");
          let doc = new DOMParser().parseFromString(newoldtext, 'text/html');
          parentDiv.replaceChild(doc.firstElementChild, oldtext);
        }
      });
      return temporalDivElement.outerHTML;
    },

    fontSizeCKeditorToVw(css) {
      // width device en px
      let width = this.getSelectedDevice[0].fixedSize
        ? this.getSelectedDevice[0].fixedSize.width
        : this.getSelectedDevice[0].width;
       width=parseFloat(width.replace('vw', ''));
      const unitCss = this.canvasSize.width / 100;
      // windowsize
      var windowsize = $(window).width()/100;
      return css.replace(/font-size:((\d)+\.?(\d)*)vw/g, val => {
        let oldValvw = parseFloat(val.replace('font-size:', '').replace('vw', ''));
        let newVal =  (unitCss * oldValvw ) ;
        let previwWidth = width * windowsize  ;// en px
        let canvasWidth = this.canvasSize.width ;// en px
        let size = ( ( newVal * previwWidth ) /canvasWidth) /  windowsize
        return 'font-size:' + size + 'vw';
      });
    },
    animationsvgBySlide(event) {
      this.timeout = 0;
      if (event.previousSlide) {
      }
      if (event.currentSlide) {
        let SvgsInPresentSlide = Array.prototype.slice.call(
          event.currentSlide.querySelectorAll('.AnimatSvg'),
        );
        if (SvgsInPresentSlide.length > 0) {
          SvgsInPresentSlide.forEach(svg => {
            this.playAnimationSVG(svg.id);
          });
        }
      }
    },

    mountOneSlide() {
      let SvgsInPresentSlide = Array.prototype.slice.call(
        document.querySelectorAll('.slides section')[0].querySelectorAll('.AnimatSvg'),
      );
      if (SvgsInPresentSlide.length > 0) {
        SvgsInPresentSlide.forEach(svg => {
          this.playAnimationSVG(svg.id);
        });
      }
    },

    /****************************/
    getHtml(html) {
      return this.getSanitizedHtml(html)
        .replace(/autoplay="autoplay"/g, 'data-autoplay="autoplay"')
        .replace(/autoplay="1"/g, 'data-autoplay="autoplay"')
        .replace(/autoplay="true"/g, 'data-autoplay="autoplay"');
    },
    loadScript() {
      this.scriptEl.text = '';
      let head = document.getElementsByTagName('head').item(0);

      this.selected.forEach((item, key) => {
        if (item.js && item.js.indexOf('<div') === -1) {
          this.scriptEl.text += '\n' + item.js;
        }
      });
      this.scriptEl.onload = function() {
        alert('Script loaded and ready');
      };
      head.appendChild(this.scriptEl);
    },
    showPreview() {
      this.$root.$emit('ShowPreview', false);
      let videoPlayers = ['video', 'player', 'video_mp4', 'playlist'];
      videoPlayers.forEach(player => {
        // this.setPausedVideo(player);
      });

      /* Check for full screen mode */
      if ((screen.availHeight || screen.height - 30) <= window.innerHeight) {
        const previewEl = document.getElementById('previewAll');
        const appEl = document.getElementById('app');
        appEl.appendChild(previewEl);
      }
      eventHub.$emit('scaleDefaultValue')
    },
    reloadSlides() {
      const self = this;
      self.scriptEl = document.createElement('script');
      this.dataStored = [];

      setTimeout(() => {
        Reveal.slide(0);
        self.loadScript();
        // self.setAutoPlayVideo(self.slideId, self.typePreview);
        const tickers = Reveal.getSlides()[0].querySelectorAll('#newsTicker');
        // self.setRevealPlayers(Reveal);
        let index = 0;
        let interval = setInterval(() => {
          index++;

          tickers.forEach(t => {
            const playBtn = t.querySelector('.bn-play');

            if (playBtn) {
              playBtn.click();
              clearInterval(interval);
            }
            if (index === 100) {
              clearInterval(interval);
            }
          });
        }, 100);
        // this.setNoMutedVideo(grapesjsEMP.editors[0]);
        self.setRevealPlayers(Reveal);
        self.setNoWidthHeightReveal();
      }, 500);

      Reveal.addEventListener('ready', function(event) {
        self.loadScript();
        self.setRevealUrlsCkeditors(event);
        //self.setAutoPlayVideo(self.slideId, self.typePreview);
      });
    },
    setNoWidthHeightReveal() {
      var slides = document.querySelector('.reveal .slides');
      slides.style.width = '';
      slides.style.height = '';
    },
    setRevealUrlsCkeditors(event) {
      if (event.previousSlide) {
        let ckEditorsUrls;
        ckEditorsUrls = event.previousSlide.querySelectorAll(
          "div[data-class='custom-sharing'] > p",
        );
        this.setTargetUrlCkEditor(ckEditorsUrls);
      }
      if (event.currentSlide) {
        let ckEditorsUrls;
        ckEditorsUrls = event.currentSlide.querySelectorAll("div[data-class='custom-sharing'] > p");
        this.setTargetUrlCkEditor(ckEditorsUrls);
      }
    },
    setTargetUrlCkEditor(ckEditorsUrls) {
      if (ckEditorsUrls && Object.keys(ckEditorsUrls).length > 0) {
        ckEditorsUrls.forEach(e => {
          let ckeditorHref = e.children[0];
          if (ckeditorHref && ckeditorHref.hasAttributes('data-cke-saved-href')) {
            ckeditorHref['target'] = '_blanc';
          }
        });
      }
    },
    setRevealPlayers(Reveal) {
      if (Reveal.getSlides()) {
        Reveal.getSlides().forEach((slide, index) => {
          let players;
          players = slide.querySelectorAll(
            "div iframe, iframe[src*='autoplay='], video, div[data-gjs-type*='video_mp4'] video",
          );
          if (players && Object.keys(players).length > 0) {
            players.forEach(p => {
              if (index === 0) {
                //this.handleFirstPlayer(p);
              } else {
                // this.handleOtherPlayers(p);
              }
            });
          }
        });
      }
    },
    handleFirstPlayer(p) {
      let src = p.getAttribute('src');
      let id = p.getAttribute('id');
      let autoplayAttr = p.getAttribute('data-autoplay');
      let video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      let extension = src.split('.').pop();
      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('a=1') + src.indexOf('autoplay=1') > -1) {
          if (src.indexOf('vimeo') === -1) {
            this.setPlayedPlayers(p, video, this.timeout);
          } else {
            this.setPlayedVimeoVideo(p, video, this.timeout);
          }
        } else {
          if (src.indexOf('vimeo') === -1) {
            this.setPausedPlayers(p, video, this.timeout);
          } else {
            this.setPausedVimeoVideo(p, video, this.timeout);
          }
        }
      } else {
        if (
          autoplayAttr === 'autoplay' ||
          autoplayAttr !== null ||
          autoplayAttr === 1 ||
          autoplayAttr === true
        ) {
          p.play();
        } else {
          p.pause();
        }
      }
    },
    handleOtherPlayers(p) {
      let src = p.getAttribute('src');
      let id = p.getAttribute('id');
      let video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      let extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        this.timeout = 100;
        if (
          video === 'iframe' &&
          (id.indexOf('player') > -1 || id.indexOf('playlist') > -1 || src.indexOf('vimeo') > -1)
        ) {
          this.timeout = 500;
        }
        if (src.indexOf('vimeo') === -1) {
          this.setPausedPlayers(p, video, this.timeout);
        } else {
          this.setPausedVimeoVideo(p, video, this.timeout);
        }
      } else {
        p.pause();
      }
    },
    slideChanged(event) {
      let self = this;
      if (event.indexh == 0) {
        self.loadScript();
      }
      self.isChanged = true;
      self.setNoWidthHeightReveal();
      this.handleFragmentsAnimation(event);
      this.handleTickers(event);
      // this.handlePlayers(event);
      this.setRevealUrlsCkeditors(event);
      //this.setAutoPlayVideo(event.indexh, self.typePreview);
      this.animationsvgBySlide(event);

    },
    handleFragmentsAnimation(event) {
      Reveal.getSlides().forEach((s, i) => {
        if (i < event.indexh) {
          const fragments = s.querySelectorAll('.fragment.visible');
          fragments.forEach(f => {
            f.classList.remove('visible');
          });
        }
      });
    },
    handleTickers(event) {
      const previousTickers = event.previousSlide.querySelectorAll('#newsTicker');
      const currentTickers = event.currentSlide.querySelectorAll('#newsTicker');

      let previousIndex = 0;
      let currentIndex = 0;
      let previousInterval = setInterval(() => {
        previousIndex++;
        previousTickers.forEach(t => {
          const pauseBtn = t.querySelector('.bn-pause');

          if (pauseBtn) {
            pauseBtn.click();
            clearInterval(previousInterval);
          }
          if (previousIndex === 100) {
            clearInterval(previousInterval);
          }
        });
      }, 100);

      let currentInterval = setInterval(() => {
        currentIndex++;
        currentTickers.forEach(t => {
          const playBtn = t.querySelector('.bn-play');
          if (playBtn) {
            playBtn.click();
            clearInterval(currentInterval);
          }
          if (currentIndex === 100) {
            clearInterval(previousInterval);
          }
        });
      }, 100);
    },
    handlePlayers(event) {
      this.timeout = 0;
      if (event.previousSlide) {
        let previousPlayers;
        previousPlayers = event.previousSlide.querySelectorAll(
          "div iframe, iframe[src*='autoplay='], video[autoplay='data-autoplay'], div[data-gjs-type*='video_mp4'] video[autoplay='data-autoplay']",
        );
        if (previousPlayers) {
          previousPlayers.forEach(p => {
            // this.handlePreviousPlayers(p);
          });
        }
      }
      if (event.currentSlide) {
        let currentPlayers;
        currentPlayers = event.currentSlide.querySelectorAll(
          "div iframe, iframe[src*='autoplay='], video[autoplay='data-autoplay'], div[data-gjs-type*='video_mp4'] video[autoplay='data-autoplay']",
        );
        if (currentPlayers) {
          currentPlayers.forEach(p => {
            //this.handleCurrentPlayers(p);
          });
        }
      }
    },
    handlePreviousPlayers(p) {
      const src = p.getAttribute('src');
      const id = p.getAttribute('id');
      const video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      let extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('vimeo') === -1) {
          this.setPausedPlayers(p, video, this.timeout);
        } else {
          this.setPausedVimeoVideo(p, video, this.timeout);
        }
      } else {
        p.pause();
      }
    },
    handleCurrentPlayers(p) {
      const src = p.getAttribute('src');
      const video = p.localName;
      const id = p.getAttribute('id');
      const autoplayAttr = p.getAttribute('data-autoplay');
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }

      let extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('a=1') + src.indexOf('autoplay=1') > -1) {
          if (src.indexOf('vimeo') === -1) {
            this.setPlayedPlayers(p, video, this.timeout);
          } else {
            this.setPlayedVimeoVideo(p, video, this.timeout);
          }
        } else {
          if (src.indexOf('vimeo') === -1) {
            this.setPausedPlayers(p, video, this.timeout);
          } else {
            this.setPausedVimeoVideo(p, video, this.timeout);
          }
        }
      } else {
        if (autoplayAttr === 'autoplay' || autoplayAttr !== null) {
          p.play();
        } else {
          p.pause();
        }
      }
    },
    setAutoPlayVideo(slide, type) {
      const self = this;
      let listVideos = self.videoObject.map(videos => {
        return videos;
      });
      listVideos.forEach((video, index) => {
        if (video) {
          let videoArray = ['video']; // 'player', 'playlist'
          if (videoArray.indexOf(video.type) > -1) {
            let srcVideo = video.src;
            let attrAutoplay;
            let videoId = video.id || video.attributes.id;
            if (video.type === 'video') {
              attrAutoplay = 'autoplay';
            } else {
              attrAutoplay = 'a';
            }
            if (type === 'preview') {
              if (
                video.autoplay === 1 &&
                video.src.indexOf(attrAutoplay + '=0') > -1 &&
                video.slide === slide
              ) {
                srcVideo = video.src.replace(attrAutoplay + '=0', attrAutoplay + '=1');
              } else {
                srcVideo = video.src.replace(attrAutoplay + '=1', attrAutoplay + '=0');
              }
            } else {
              srcVideo = video.src.replace(attrAutoplay + '=0', attrAutoplay + '=1');
            }
            this.setAutoplay(videoId, srcVideo, type);
          }
        }
      });
    },
    setAutoplay(videoId, srcVideo, type) {
      if (videoId) {
        setTimeout(() => {
          let iframe = document.querySelector('.gjs-frame').contentWindow;
          let videoEl;
          if (type === 'preview') {
            videoEl = document.querySelector('#' + videoId);
          } else {
            videoEl = iframe.document.querySelector('#' + videoId + ' > iframe');
          }
          if (videoEl) {
            videoEl.setAttribute('src', srcVideo);
          }
        }, 100);
      }
    },
  },
  created() {
    const self = this;
    self.$root.$on('ShowPreview', val => {
      self.scale = self.getScalingZoomAll();
      self.scaleValue('.preview-scaling',self.scale.percent/100,self.scale.ty,self.scale.tx)
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(() => {
        if (!val) {
          self.isChanged = false;
          Reveal.slide(self.selected.length - 1);
        }
        this.isVisible = val;
      }, 100);

      /* Check for full screen mode */
      if ((screen.availHeight || screen.height - 30) <= window.innerHeight) {
        const previewEl = document.getElementById('previewAll');
        const editorEl = document.getElementById('editor');
        editorEl.appendChild(previewEl);
      }
    });
    self.$root.$on('AutoPlayVideoPreview', obj => {
      self.videoObject = obj.video;
      self.typePreview = obj.type;
      // self.setAutoPlayVideo(self.getCurrentSlideIndex, self.typePreview);
    });
  },
  mounted() {
    let self = this;
    Reveal.addEventListener('slidechanged', self.slideChanged);

    Reveal.addEventListener('overviewshown', function(event) {
      self.overviewShown = true;
    });
    Reveal.addEventListener('overviewhidden', function(event) {
      self.overviewShown = false;
    });
  },
  destroyed() {
    var x = document.getElementById('twitter-wjs');
    if (x) {
      x.parentNode.removeChild(x);
    }
  },
};
</script>

<style lang="scss">
@import '../scss/reveal.scss';

.previewDisplay {
  visibility: hidden;
  z-index: 0;
  display: none;
  &.is-visible-preview{
    visibility: visible;
    z-index: 10;
    display: block;
  }
  &.overviewShown {
    .reveal .slides.landscape {
      overflow: visible;
    }
  }
  &#previewAll {
    position: fixed;
    top: 0;
    background: aliceblue;
    height: 100%;
    width: 100%;

  }
  .exit_preview {
    position: fixed;
    top: -40px;
    z-index: 101;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    background: none;
    padding: 10px;
    height: 15%;
    transition: top 0.3s;
    fill: #333;
    opacity: 0.8;
    &:hover {
      top: 0;
    }
    .exit-container {
      width: 100%;
      display: flex;
      justify-content: center;
      .exit-alert {
        display: flex;
        text-align: center;
        justify-content: space-between;
      }
    }

    #animatedExit {
      -webkit-animation-duration: 3s;
      animation-duration: 3s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      position: fixed;
      top: 60px;
      background-color: #00000082;
      color: white;
      padding: 0px 35px;
      border-radius: 3px;
      overflow: hidden;
      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);

      svg {
        height: 50px;
        margin: 5px;
      }
    }
    @-webkit-keyframes fadeOutUp {
      0% {
        opacity: 1;
        -webkit-transform: translateY(0);
      }
      80% {
        opacity: 1;
        -webkit-transform: translateY(0);
      }
      100% {
        opacity: 0;
        -webkit-transform: translateY(-20px);
      }
    }

    @keyframes fadeOutUp {
      0% {
        opacity: 1;
        transform: translateY(0);
      }
      80% {
        opacity: 1;
        transform: translateY(0);
      }
      100% {
        opacity: 0;
        transform: translateY(-20px);
      }
    }

    .fadeOutUp {
      -webkit-animation-name: fadeOutUp;
      animation-name: fadeOutUp;
    }
  }
}

.reveal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #e2e5ec !important;
  z-index: 100;
  .slides,
  .slidesParent {
    text-align: left !important;
    background-color: #fff;
    section {
      padding: 0 !important;
      height: 100%;
      top: 0 !important;
    }
    section[hidden] {
      display: block !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Preview.vue?542bc29b